module.exports = __webpack_public_path__ + "static/media/global-nav-final.c9e63050.gif";